import React from "react";
import { useEffect } from "react";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import UnstyledInputGeneralComponent from "../../UnstyledInputGeneralComponent/UnstyledInputGeneralComponent";

type TSearchOverlayShellProps = {
    isOpen: boolean;
    searchValue: string;
    placeholder: string;
    onChange: (searchValue: string) => void;
    onClose: () => void;
    // A caller that needs to put focus back on the input — Sail Legal does, after its
    // property-report toggle — has to own the ref. Without this the caller's ref points at
    // nothing, its focus() call silently no-ops, and Escape stops closing the overlay
    // because the input is what handles it.
    inputRef?: React.RefObject<HTMLInputElement>;
};

// The shadowbox, the big input and the result column, shared by the Sail Legal case search
// and the Sail Homes search. It keeps the crm-case-search-overlay class names because it IS
// that overlay — only the contents differ per brand.
export const CRMSearchOverlayShell = (props: React.PropsWithChildren<TSearchOverlayShellProps>): JSX.Element => {
    const rootRef = React.createRef<HTMLDivElement>();
    const ownInputRef = React.createRef<HTMLInputElement>();
    const inputRef = props.inputRef ?? ownInputRef;

    const closeIfShadowboxWasClicked = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (rootRef.current?.isSameNode(event.target as Node)) {
            props.onClose();
        }
    };

    useEffect(
        () => {
            if (props.isOpen) {
                inputRef.current?.focus();
            }
        },
        [props.isOpen]
    );

    return (
        <div
            ref={rootRef}
            className={`
                crm-case-search-overlay
                crm-case-search-overlay--${props.isOpen ? "open" : "closed"}
            `}
            onClick={closeIfShadowboxWasClicked}
        >
            {props.isOpen &&
                <div className="crm-case-search-overlay__body">

                    <div className="crm-case-search-overlay__big-input-wrap">
                        <UnstyledInputGeneralComponent
                            inputRef={inputRef}
                            className="crm-case-search-overlay__big-input"
                            placeholder={props.placeholder}
                            inputType="text"
                            value={props.searchValue}
                            onChange={props.onChange}
                            onPressEscape={props.onClose}
                            displayError={false}
                        />
                    </div>

                    <div className="crm-case-search-overlay__cards">
                        <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                            {props.children}
                        </SpacingColumn>
                    </div>

                </div>
            }
        </div>
    );
};
